// src/constants/TaskConstants.js
import { common, warning, grey } from 'src/theme/palette';

export const TASK_STATUS = {
    PENDING: 'pending',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    ARCHIVED: 'archived',
};

export const TASK_PRIORITY = {
    URGENT: 'urgent',
    HIGH: 'high',
    NORMAL: 'normal',
    LOW: 'low',
};

export const TASK_CATEGORY = {
    LEAD_MARKETING: 'lead_marketing',
    PATIENT_CARE: 'patient_care',
    CLINICAL: 'clinical',
    OPERATIONAL: 'operational',
    COMPLIANCE: 'compliance',
    // Lifecycle-aware categories (post-2026-05). NEW_LEAD is the V2 home
    // for the V1 NEW_LEAD reminder group; FOLLOW_UP is the V2 home for
    // every other V1 group under the new default rules.
    NEW_LEAD: 'new_lead',
    FOLLOW_UP: 'follow_up',
};

export const TASK_METHOD = {
    CALL: 'call',
    EMAIL: 'email',
    WHATSAPP: 'whatsapp',
    PAYMENT: 'payment',
    OTHER: 'other',
};

export const PRIORITY_COLORS = {
    urgent: common.tomatoRed,
    high: warning.main,
    normal: common.skyBlue,
    low: grey[500],
};

export const STATUS_COLORS = {
    pending: warning.main,
    in_progress: common.skyBlue,
    completed: common.mintyZest,
    archived: grey[500],
};

export const CATEGORY_LABELS = {
    lead_marketing: 'Lead & Marketing',
    patient_care: 'Patient Care',
    clinical: 'Clinical',
    operational: 'Operational',
    compliance: 'Compliance',
    new_lead: 'New Lead',
    follow_up: 'Follow Up',
};
